
import CategoryElement from "@/components/base/card/CategoryElement"
import { mapGetters } from "vuex"

export default {
    components: {
        CategoryElement,
    },
    data() {
        return {
            links: [
                {
                    cat: "Ausbildung",
                    img:
                        this.$ua.browser() === "Chrome" && !this.$ua.isFromIos()
                            ? require("@/assets/images/categories/ausbildung.webp")
                            : require("@/assets/images/categories/ausbildung.jpg"),
                    webpImg: "/images/ausbildung.webp",
                    prefix: "Durchstöbere",
                    text: "Ausbildungsplätze",
                },
                {
                    cat: "Praktikum",
                    img:
                        this.$ua.browser() === "Chrome" && !this.$ua.isFromIos()
                            ? require("@/assets/images/categories/praktikum.webp")
                            : require("@/assets/images/categories/praktikum.jpg"),
                    webpImg: "/images/praktikum.webp",
                    prefix: "Erkunde",
                    text: "Praktikumsplätze",
                },
                {
                    cat: "Unternehmen",
                    img:
                        this.$ua.browser() === "Chrome" && !this.$ua.isFromIos()
                            ? require("@/assets/images/categories/unternehmen.webp")
                            : require("@/assets/images/categories/unternehmen.jpg"),
                    webpImg: "/images/unternehmen.webp",
                    prefix: "Suche nach deiner",
                    text: "Wunschfirma",
                },
                {
                    cat: "Alles",
                    img:
                        this.$ua.browser() === "Chrome" && !this.$ua.isFromIos()
                            ? require("@/assets/images/categories/news.webp")
                            : require("@/assets/images/categories/news.jpg"),
                    webpImg: "/images/news.webp",
                    prefix: "Entdecke deine",
                    text: "Beruflichen Möglichkeiten",
                },
            ],
        }
    },
    computed: {
        ...mapGetters("search", {
            selectedCategory: "selectedCategory",
        }),
    },
}
